import { keycloak } from '@/keycloak';
import { builder } from '@/util/container';
import { KEYCLOAK } from '.';

export default builder(({ provide }) => {
  provide(KEYCLOAK, async () => keycloak);
});
